let styles = {
    container: {
        textAlign: 'left',
        width: '100%',
        // width: '90%',
        // margin: 'auto',
    },
    toolsItem: {
        backgroundColor: '#fff',
        width: '90px',

        display: 'inline-block',
        margin: '10px',
        position: 'relative',
        color: '#fff',
        verticalAlign: 'top',
        textAlign: 'center',
    },
    toolAvatar: {
        padding: '15px',
        height: '60px',
        lineHeight: '60px',
        borderRadius: '25px',
    },
    description: {
        fontSize: '12px',
        color: '#000',
        padding: '5px',
    },
};
export default styles;